var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["gift-card/product-gift-card-name.j2"] = require( "gift-card/product-gift-card-name.j2" );
dependencies["gift-card/product-gift-card-emailAddress.j2"] = require( "gift-card/product-gift-card-emailAddress.j2" );
dependencies["gift-card/product-gift-card-message.j2"] = require( "gift-card/product-gift-card-message.j2" );
dependencies["gift-card/product-gift-card-deliveryDate.j2"] = require( "gift-card/product-gift-card-deliveryDate.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/gift-card/product-gift-card.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isEgiftCard")) {
output += "\n\n    <div class=\"dom-product-gift-card\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("gift-card/product-gift-card-name.j2", false, "product/templates/gift-card/product-gift-card.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("gift-card/product-gift-card-emailAddress.j2", false, "product/templates/gift-card/product-gift-card.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("gift-card/product-gift-card-message.j2", false, "product/templates/gift-card/product-gift-card.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("gift-card/product-gift-card-deliveryDate.j2", false, "product/templates/gift-card/product-gift-card.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n            </div>\n\n        </div>\n\n    </div>";
})})})})})})})});
}
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/gift-card/product-gift-card.j2"] , dependencies)